//import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import ContextualManagerComponent from './js/contextual-manager.component';

ComponentsFactory.getInstance().define('contextual-manager', ContextualManagerComponent);
